export default __webpack_public_path__ + "static/media/IMG_2226 copie.0e1c029d.jpg";